import i18n from "i18next";
import Backend from "i18next-locize-backend";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import LocalStorageBackend from 'i18next-localstorage-backend'; // primary use cache
import LocizeBackend from "i18next-locize-backend";
import ChainedBackend from "i18next-chained-backend";

i18n
  .use(LanguageDetector)
  .use(ChainedBackend)
  .use(initReactI18next)
  .init({
    lng: "en",
    fallbackLng: ["en"],
    ns: ["translations"],
    defaultNS: "translations",
    supportedLngs: ["en", "ar", "es", "fr", "id-ID", "ko", "it", "ja", "de-BE", "zh", "tr", "ru"],
    preload: ["en", "ar", "es", "fr", "id-ID", "tr"],
    debug: process.env.REACT_APP_I18NEXT_DEBUG === "true",
    keySeparator: false,
    nsSeparator: false,
    // saveMissing: process.env.NODE_ENV === "production",
    backend: {
      backends:
        [
          LocalStorageBackend,
          LocizeBackend
        ],
        backendOptions: [
        {
          expirationTime: 1* 24 * 60 * 60 * 1000  //2min for now 1* 24 * 60 * 60 * 1000 // 1 day for now make it more latter
        }, 
        {
          projectId: process.env.REACT_APP_LOCIZE_PROJECT_ID,
          apiKey: process.env.REACT_APP_LOCIZE_API_KEY,
          referenceLng: "en",
          allowedAddOrUpdateHosts: ["hesaab.dev-site.me", "hesaab.wpholding.com", "https://localhost:3000", "https://hesaabaccounting.com"],
        }]
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  });

export const ar = i18n.cloneInstance({
  lng: "ar",
});

export const fr = i18n.cloneInstance({
  lng: "fr",
});

export const es = i18n.cloneInstance({
  lng: "es",
});

export const id = i18n.cloneInstance({
  lng: "id-ID",
});

export const en = i18n.cloneInstance({
  lng: "en",
});

export const it = i18n.cloneInstance({
  lng: "it",
});

export const ko = i18n.cloneInstance({
  lng: "ko",
});

export const de = i18n.cloneInstance({
  lng: "de-BE",
});

export const ja = i18n.cloneInstance({
  lng: "ja",
});

export const zh = i18n.cloneInstance({
  lng: "zh",
});

export const tr = i18n.cloneInstance({
  lng: "tr",
});
export const ru = i18n.cloneInstance({
  lng: "ru",
});

export default i18n;
